import { useEffect } from 'react';
const TAWK_SRC = 'https://embed.tawk.to/661dbc421ec1082f04e2c77f/1hri2eppl';
const SCRIPT_ID = 'tawk-to-embed';
declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}

/**
 * Loads the Tawk.to live chat widget and pins it to the bottom-left corner
 * so it never collides with the sticky header CTAs.
 */
export function TawkChat() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: 'bl',
          xOffset: 20,
          yOffset: 20
        },
        mobile: {
          position: 'bl',
          xOffset: 12,
          yOffset: 12
        }
      }
    };
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = TAWK_SRC;
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');
    const first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) {
      first.parentNode.insertBefore(script, first);
    } else {
      document.body.appendChild(script);
    }
  }, []);
  return null;
}